/**
 * @fileoverview
 * Application Configuration Constants
 * 
 * @version 1.0.0
 * @author KATALYST TEAM
 */

export const APP_CONFIG = {
  // Application Info
  APP_NAME: 'LOS Audit System',
  APP_VERSION: '1.0.0',
  APP_DESCRIPTION: 'Loan Origination System Audit Management',
  
  // Pagination
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [5, 10, 25, 50, 100],
  
  // Date Formats
  DATE_FORMAT: 'dd/MM/yyyy',
  DATE_TIME_FORMAT: 'dd/MM/yyyy HH:mm:ss',
  TIME_FORMAT: 'HH:mm:ss',
  
  // File Upload
  MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
  ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/gif'],
  ALLOWED_DOCUMENT_TYPES: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  
  // Validation
  PASSWORD_MIN_LENGTH: 8,
  PASSWORD_PATTERN: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
  EMAIL_PATTERN: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  
  // UI
  TOAST_DURATION: 3000, // 3 seconds
  DEBOUNCE_TIME: 300, // 300ms
  ANIMATION_DURATION: 200, // 200ms
  
  // HTTP
  REQUEST_TIMEOUT: 30000, // 30 seconds
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000, // 1 second
} as const;

